import { factory } from "../../../utils/apiThunkFactory"

export const updateExternalUser = factory.post("InscriptionConference/updateExternalUser", "/api/conference-inscripton/update_external_user");
export const getBookingByUrl = factory.get("InscriptionConference/getBookingByUrl", "/api/conference-inscripton/get-by-registration-link");